module.exports = __webpack_public_path__ + "static/media/Habilidades-ensinoMed-curto.4cad102b.png";